<template>
  <el-row :gutter="20">
    <el-col :span="24">
      <div class="form-group !mb-4">
        <label
          class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
        >
          Select Tag
        </label>
        <div class="grid grid-cols-[1fr_auto] !gap-3">
          <el-select v-model="field.tags" multiple placeholder="Select Tag" filterable>
            <el-option
              v-for="(item, index) in this.getAllGlobalVariableTags.data"
              :key="index"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
          <el-popover v-model="addTagVisible" placement="right-end">
            <AddTag
              v-if="addTagVisible"
              v-on:closed="closeAddTag"
              v-on:tag-added="setNewTag"
            ></AddTag>
            <el-button
              slot="reference"
              class="bg-brand-500 hover:bg-brand-500 !border-none text-white !py-2 px-3 !m-0 !h-auto rounded-md font-normal"
              size="mini"
              type="primary"
            >
              <div class="flex items-center !gap-1">
                <img alt="icon" src="@/assets/img/icons/new/add-icon.svg" class="!size-3" />
                <span class="text-xs 2xl:text-smd font-normal">New</span>
              </div>
            </el-button>
          </el-popover>
        </div>
        <FormError error-key="tag" />
      </div>
    </el-col>
  </el-row>
</template>

<script>
  import FormError from '@/components/form/FormError';
  import { mapGetters } from 'vuex';
  import AddTag from './AddTag';

  export default {
    /**
     * Components properties.
     *
     * @type {Object}
     */
    props: ['field'],

    /**
     * Components child components.
     *
     * @type {Object}
     */
    components: {
      FormError,
      AddTag,
    },

    /**
     * Components initial properties.
     *
     * @type {Object}
     */
    data() {
      return {
        addTagVisible: false,
      };
    },

    /**
     * Components computed properties.
     *
     * @type {Object}
     */
    computed: {
      logoUploadUrl() {
        return process.env.VUE_APP_S3_BUCKET_URL;
      },
      ...mapGetters('globalVariables', ['getAllGlobalVariableTags', 'getGlobalVariableErrors']),
    },

    /**
     * Components mounted life hook.
     *
     * @type {Object}
     */
    async mounted() {
      await this.fetchAllGlobalVariableTags();
    },

    /**
     * Components methods.
     *
     * @type {Object}
     */
    methods: {
      setNewTag({ data }) {
        this.field.tags.push(data._id);
        this.closeAddTag();
      },
      closeAddTag() {
        this.addTagVisible = false;
      },
      async fetchAllGlobalVariableTags() {
        await this.$store.dispatch('globalVariables/fetchGlobalVariableTags');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .add-field-btn {
    margin-left: 0.5em;
    padding: 0.75em 1em;
    position: relative;
  }

  @media (max-width: 767px) {
    .add-field-btn {
      width: 70px !important;
      margin-left: 15px;
    }
  }
</style>
